import React from 'react';
import { withRouter } from 'react-router-dom';
import { relatorioAction } from '../../store/relatorio';

//HELPERS
import * as c from '../../helpers/constants';
import { callApi } from '../../helpers/methods';
import { isBlank } from '../../helpers/stringHelper';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import {Row, Column, IBox, Title, Content, Button, Icon, Select} from '../inspinia';
import Pagination from "react-js-pagination";
import Table from './tableDetalheContato'
import TableNaoRecebidos from './tableResumoNaoRecebidos';
import TableEnvioLeitura from './tableResumoEnvioLeitura';
import TableVolumetria from './tableVolumetria';
import TableEmailsValidadosOuInvalidos from './tableEmailsvalidadosOuInvalidos';
import TableEnvioLeituraPorCampanha from './tableResumoEnvioLeituraPorCampanha';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TableDetalheContatoSms from './tableDetalheContatoSms';

//MASK
import InputMask from 'react-input-mask';

//EXPORT
import TableVolumetriaEmailsValidados from './tableVolumetriaEmailsValidados';
import TableCampanhaAdesao from './tableCampanhaAdesao';
import TemPermissao from '../../helpers/TemPermissao';
import { ROLE_EMAIL } from '../../store/roles';

class EnvioVerificaMontreal extends React.PureComponent
{
    
    constructor(props)
    {
        super(props);    
    
        this.state = {
            isGoing: true,
            novoAcesso: true,
            loading: false,
            pageInit: 0,
            isLoggedIn: true,
            tableAux: "",
            combosDisabled: false,
            botaoDisabled: false,
            labelDataInicio: "Data do envio da campanha (Início):",
            labelDataFim: "Data do envio da campanha (Fim):",
            labelDataInicioCampanha: "Data do envio da campanha (Início):",
            labelDataFimCampanha: "Data do envio da campanha (Fim):",
            labelDataInicioEmailsValidados: "Data da validação dos e-mails (Início):",
            labelDataFimEmailsValidados: "Data da validação dos e-mails (Fim):",
            labelEmailOuTelefone: "Contato:",
                        
            form: this.formInitialState(),
            list: 
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, results: undefined
            },
            comboEmpresa: 
            {
                results: undefined
            },
            comboStatus: 
            {
                results: undefined
            }, 
            comboTipoRelatorio: 
            {
                results: undefined
            },
            comboMotivos: 
            {
                results: undefined
            }, 
            comboCentroCusto: 
            {
                results: undefined
            },
            comboNomeCampanhas:
            {
                results: undefined
            }, 
            comboNomeCampanhasAutoComplete: [],
            campanhaValues: {
                value: "",
                label: ""
            }
        }

        this.handlePesquisarRelatorio = this.handlePesquisarRelatorio.bind(this);
        this.handleChange             = this.handleChange.bind(this);
        this.handlePageChange         = this.handlePageChange.bind(this);
        this.handleChangeCombo        = this.handleChangeCombo.bind(this);
        this.handleLimparPesquisa     = this.handleLimparPesquisa.bind(this);
        this.handlePesquisarRelatorioEmail = this.handlePesquisarRelatorioEmail.bind(this);
        this.onNomeCampanhaChange = this.onNomeCampanhaChange.bind(this);
    }


    formInitialState () 
    {
        return {
            campanha: "",
            empresa: "",
            nomeContato: "",
            status: "",
            email: "",
            motivo: "",
            dataInicio: "",
            dataFim: "",
            tipoRelatorio: "",
            tipoEnvio: 'Rastreado Verificar',
            centroCusto: "",
        }
    }

    componentDidMount() {   
        this.LoadComboEmpresa();
        this.LoadComboNomeCampanhas();
        this.LoadComboMotivos();
        this.LoadComboTipoRelatorio();
        //Retirado para evitar carregar relatório ao abrir página.
        //Remover comentário na próxima release
        //this.handleRelatorio(); 
        this.LoadListaCentroCusto();
    }

    handleChange(e) {
        const form = this.state.form;
        this.state.isLoggedIn = false;
        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    onNomeCampanhaChange = (event, values) => {
        const form = this.state.form;
        let campanhaCombo = '';
        
        if (values) {
            campanhaCombo = values.value;
        }
        
        this.setState({ form: { ...form, 'campanha': campanhaCombo } });
        this.setState({ ...this.state, campanhaValues: values });
    }

    handleChangeCombo(e) {
        this.state.isLoggedIn = false;
        this.state.form.tipoRelatorio = e.target.value;

        if (e.target.value == 7) {
            this.setState({
                ...this.state,
                botaoDisabled: false,
                combosDisabled: true,
                labelDataInicio: this.state.labelDataInicioEmailsValidados,
                labelDataFim: this.state.labelDataFimEmailsValidados
            });
        } else if (e.target.value == 5 || e.target.value == 6) {
            this.setState({
                ...this.state,
                botaoDisabled: true,
                combosDisabled: false,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        } else {
            this.setState({
                ...this.state,
                botaoDisabled: false,
                combosDisabled: false,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        }
    }

    handlePesquisarRelatorio() {  
       this.state.list = [];
       this.state.isLoggedIn = true;
       this.state.page = 1;
       this.handleRelatorio();
    }

    handlePesquisarRelatorioEmail() {  
        this.state.list = [];
        this.state.isLoggedIn = true;
        this.state.page = 1;
        this.handleRelatorioEmail();
     }

    handleLimparPesquisa(){
        this.state.list = [];
        this.state.form.tipoRelatorio = "0";
        this.state.form.campanha = "";
        this.state.campanhaValues = {value: "", label: ""}
        this.state.form.empresa = "";
        this.state.form.centroCusto = "";
        this.state.form.nomeContato = "";
        this.state.form.status = "";
        this.state.form.email = "";
        this.state.form.motivo = "";
        this.state.form.dataInicio = "";
        this.state.form.dataFim = "";
        this.state.form.tipoRelatorio = "";
        this.LoadTable();
    }

    handlePageChange(pageNumber) {
        this.state.page = pageNumber;
        this.handleRelatorio(pageNumber);
    }

    handleRelatorio(pageNumber) {
        this.LoadTable(pageNumber);
    }

    handleRelatorioEmail() {
        this.LoadTableEmail();
    }

    render()
    {
        const form = this.state.form;
        const campanhas = this.state.comboNomeCampanhasAutoComplete;          
        const isLoggedIn = this.state.isLoggedIn;
        let table;

        if( isLoggedIn ) {

            if(form.tipoRelatorio === "0"){
                table  = <Table data={this.state.list} history={this.props.history}/>; 
            } else if(form.tipoRelatorio === "1"){
                table  = <TableEnvioLeitura data={this.state.list} history={this.props.history}/>;
            } else if(form.tipoRelatorio === "2") {
                table  = <TableNaoRecebidos data={this.state.list} history={this.props.history}/>;
            } else if(form.tipoRelatorio === "3" || form.tipoRelatorio === "10") {
                table  = <TableVolumetria data={this.state.list} history={this.props.history}/>;
            }else if(form.tipoRelatorio === "4") {
                table  = <TableEnvioLeituraPorCampanha data={this.state.list} history={this.props.history}/>;
            } else if(form.tipoRelatorio === "5") {
                table = <TableEmailsValidadosOuInvalidos data={this.state.list} history={this.props.history} tipoRelatorio={form.tipoRelatorio} />
            } else if(form.tipoRelatorio === "6") {
                table = <TableEmailsValidadosOuInvalidos data={this.state.list} history={this.props.history} tipoRelatorio={form.tipoRelatorio} />
            } else if (form.tipoRelatorio === "7") {
                table = <TableVolumetriaEmailsValidados data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "8") {
                table = <TableCampanhaAdesao data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "9") {
                table  = <TableDetalheContatoSms data={this.state.list} history={this.props.history}/>;
            }

            this.state.tableAux = table;
        }else {
            table = this.state.tableAux;
        }

        return (            
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Envio VerificaMontreal - Buscar relatório</h3>
                            </Title>
                            
                            <Content>
                                <Row className="form-row">
                                    <div className="form-group col-md-6">
                                        <label>Campanha:</label>     
                                        <Autocomplete
                                            id="combo-campanha"
                                            options={campanhas}
                                            getOptionLabel={(option) => option.label}
                                            style={{marginTop:-8}}
                                            onChange={this.onNomeCampanhaChange}
                                            disabled={this.state.combosDisabled}
                                            value={this.state.campanhaValues}
                                            getOptionSelected={(option) => option.value}
                                            renderInput={
                                                (params) => 
                                                <TextField 
                                                    {...params} 
                                                    variant="outlined"  
                                                    margin="dense"
                                                /> 
                                            }
                                        /> 
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>Empresa:</label>
                                        <Select name="empresa" selected={form.empresa} data={this.state.comboEmpresa} onChange={this.handleChange} placeholder="Empresa"  />
                                    </div>                                    
                                </Row> 

                                <Row className="form-row">
                                    <div className="form-group col-md-4">
                                        <label>Nome Contato:</label>     
                                        <input type="text" name="nomeContato" value={form.nomeContato} onChange={this.handleChange} className="form-control" disabled={this.state.combosDisabled } />
                                    </div>
                                    
                                    <div className="form-group col-md-4">
                                        <label>{ this.state.labelEmailOuTelefone }</label>
                                        <input type="text" name="email" value={form.email} onChange={this.handleChange} className="form-control" disabled={this.state.combosDisabled }/>
                                    </div>
                                    
                                    <TemPermissao permissao={ROLE_EMAIL}>
                                        <div className="form-group col-md-4">
                                            <label>Motivo:</label>
                                            <Select name="motivo" selected={form.motivo} data={this.state.comboMotivos} onChange={this.handleChange} placeholder="Motivo" disabled={ this.state.combosDisabled }  />
                                        </div>
                                    </TemPermissao>                                
                                </Row>

                                <Row className="form-row">
                                    <div className="form-group col-md-4">
                                        <label>{ this.state.labelDataInicio }</label>
                                        <InputMask mask="99/99/9999" name="dataInicio" value={form.dataInicio} placeholder="___/___/___" onChange={this.handleChange} className="form-control"/>                                           
                                    </div>  

                                    <div className="form-group col-md-4">
                                        <label>{ this.state.labelDataFim }</label>
                                        <InputMask mask="99/99/9999" name="dataFim" value={form.dataFim} placeholder="___/___/___" onChange={this.handleChange} className="form-control"/>                                           
                                    </div> 
                                    <div className="form-group col-md-4">
                                        <label>Centro de Custo:</label>
                                        <Select name="centroCusto" selected={form.centroCusto} data={this.state.comboCentroCusto} onChange={this.handleChange} placeholder="Centro de Custo"  />
                                    </div>                              
                                </Row>

                                <Row className="form-row">
                                    <div className="form-group col-md-3">
                                        <label>Filtros:</label>
                                        <Select name="tipoRelatorio" selected={form.tipoRelatorio} data={this.state.comboTipoRelatorio} onChange={this.handleChangeCombo} placeholder="Tipo Relatório"  />
                                    </div>
                                    <div className="form-group col-md-1" style={{marginTop:'28px', marginLeft:"5px"}}>
                                        <Button onClick={this.handlePesquisarRelatorio}><Icon name="far fa-search"/> Pesquisar</Button>
                                    </div>
                                    <div className="form-group col-md-1" style={{marginTop:'28px', marginLeft:"40px"}}>
                                        <Button onClick={this.handlePesquisarRelatorioEmail} disabled={this.state.botaoDisabled}><Icon name="far fa-search"/>Relatório por e-mail</Button>
                                    </div>
                                    <div className="form-group col-md-1" style={{marginTop:'28px', marginLeft:"102px"}}>
                                        <Button onClick={this.handleLimparPesquisa}><Icon name="far fa-trash"/> Limpar</Button>
                                    </div>                                                             
                                </Row> 

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">                                        
                                        {table}
                                    </Column>
                                </Row>                                

                            </Content>

                        </IBox>                     
                    </Column>
                </Row>


                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">                 
                                    
                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.pageSize}
                                        totalItemsCount={this.state.list.rowCount}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>  
                        </Row>
                    </Column>
                </Row>

            </div>
        );
    }

    LoadListaCentroCusto() {
        let self = this;        
        
        const url = `${c.API_BASE_URL}/combo-centroCusto`;
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, comboCentroCusto: response});
        });

    }

    LoadComboNomeCampanhas() {
        let self = this;

        const url = `${c.API_CAMPAIGN_URL}/public/campaign/campaign-name`;
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboNomeCampanhas: response });
            self.setState({ ...self.state, loading: false, comboNomeCampanhasAutoComplete: response.results });
        });
    }

    LoadComboEmpresa() {
        let self = this;
        const data = JSON.stringify({
            'id_produto': null
        });
        const url = `${c.API_BASE_URL}/company-user`;
        const options =
        {
            method: 'POST'
            ,headers: { 'Content-Type': 'application/json' }
            ,body: data
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboEmpresa: response });
        });
    }

    LoadComboMotivos()
    {
        let self = this;

        const url = `${ c.API_BASE_URL }/reasonNotReceive`;
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, comboMotivos: response});
        });
    }

    LoadComboTipoRelatorio()
    {
        let self = this;

        const url = `${ c.API_BASE_URL }/typeReports`;
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, comboTipoRelatorio: response});
        });
    }

    LoadTable(pageNumber)
    {
        let self = this;
        let page = pageNumber === undefined ? 0 : --pageNumber;

        let tipoRelatorio = this.state.form.tipoRelatorio === "" ? 0 : this.state.form.tipoRelatorio;

        let empresa = this.state.form.empresa === "Selecione..." ? "" : this.state.form.empresa;
        let status = this.state.form.status === "Selecione..." ? "" : this.state.form.status;
        let motivo = this.state.form.motivo === "Selecione..." ? "" : this.state.form.motivo;
        let centroCusto = this.state.form.centroCusto === "Selecione..." ? "" : this.state.form.centroCusto;
        let idUsuario = self.props.auth.user.id;
        let nomeCampanha = this.state.form.campanha;     
        
        if (this.tipoRelatorioNecessitaEmpresa(tipoRelatorio) && isBlank(empresa)) {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar o filtro empresa.");
            return;
        }

        const url = `${ c.API_BASE_URL }/relatorio`;
        const options =
        {
            method: 'POST' 
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({
                page: page,
                idCampanha: this.state.campanhaValues.value,
                idEmpresa:  empresa,
                nomeContato: this.state.form.nomeContato,
                status: status,
                emailContato: this.state.form.email,
                motivo: motivo,
                dataEnvioInicio: this.state.form.dataInicio,
                dataEnvioFim: this.state.form.dataFim,
                tipoRelatorio: tipoRelatorio,
                tipoEnvio: 'Rastreado Verificar',
                idCentroCusto: centroCusto
            })
        };
    
        self.setState({...self.state, loading: true})
        
        callApi(url, options, function(response)
        {
            if (self.state.loading || self.state.novoAcesso) {
                self.setState({ ...self.state, loading: false, novoAcesso: false, list: response });
            }
        });  
       
    }

    tipoRelatorioNecessitaEmpresa(tipoRelatorio) {
        return (tipoRelatorio == 3 || tipoRelatorio == 5 || tipoRelatorio == 6 || tipoRelatorio == 7 || tipoRelatorio == 10);
    }

    tipoRelatorioNecessitaDataInicio(tipoRelatorio) {
        return (tipoRelatorio == 9 || tipoRelatorio === "10");
    }

    LoadTableEmail()
    {
        let self = this;
        let page = 0;

        let tipoRelatorio = this.state.form.tipoRelatorio === "" ? 0 : this.state.form.tipoRelatorio;

        let empresa = this.state.form.empresa === "Selecione..." ? "" : this.state.form.empresa;
        let status = this.state.form.status === "Selecione..." ? "" : this.state.form.status;
        let motivo = this.state.form.motivo === "Selecione..." ? "" : this.state.form.motivo;
        let centroCusto = this.state.form.centroCusto === "Selecione..." ? "" : this.state.form.centroCusto;
        let idUsuario = self.props.auth.user.id;
        let nomeCampanha = this.state.form.campanha;  

        if(isBlank(empresa)) {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar a Empresa");

        } else {

            const url = `${ c.API_BASE_URL }/relatorio/email`;
            const options =
            {
                method: 'POST' 
                ,headers: { 'Content-Type': 'application/json' }
                ,body: JSON.stringify({
                    page: page,
                    idCampanha: this.state.form.campanha,
                    idEmpresa:  empresa,
                    nomeContato: this.state.form.nomeContato,
                    status: status,
                    emailContato: this.state.form.email,
                    motivo: motivo,
                    dataEnvioInicio: this.state.form.dataInicio,
                    dataEnvioFim: this.state.form.dataFim,
                    tipoRelatorio: tipoRelatorio,
                    tipoEnvio: 'Rastreado Verificar',
                    idUsuario: idUsuario,
                    idCentroCusto: centroCusto
                })
            };

            callApi(url, options, function(response)
            { 
                if(response.status === 'OK'){
                    c.TOASTER_SUCCESS("Relatório sendo gerado, ao finalizar o processamento o relatório será enviado ao e-mail do usuário logado."); 
                }else{
                    c.TOASTER_ERROR(response.message); 
                }
            });

        }
    }

}


function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EnvioVerificaMontreal));
